const PWAInstructionLogo = () => {
	return (
		<svg width='100%' height='100%' viewBox='0 0 393 374' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M332.5 346V77C332.5 52.1472 312.353 32 287.5 32H105.5C80.6472 32 60.5 52.1472 60.5 77V346C60.5 348.209 58.7091 350 56.5 350C54.2909 350 52.5 348.209 52.5 346V77C52.5 47.7289 76.2289 24 105.5 24H287.5C316.771 24 340.5 47.7289 340.5 77V346C340.5 348.209 338.709 350 336.5 350C334.291 350 332.5 348.209 332.5 346Z'
				fill='#EDEDEF'
			/>
			<path
				d='M151.5 53C151.5 45.8203 157.32 40 164.5 40H228.5C235.68 40 241.5 45.8203 241.5 53C241.5 60.1797 235.68 66 228.5 66H164.5C157.32 66 151.5 60.1797 151.5 53Z'
				fill='#EDEDEF'
			/>
			<path
				d='M71.5 110C71.5 102.82 77.3203 97 84.5 97H110.5C117.68 97 123.5 102.82 123.5 110V136C123.5 143.18 117.68 149 110.5 149H84.5C77.3203 149 71.5 143.18 71.5 136V110Z'
				fill='#EDEDEF'
			/>
			<path
				d='M71.5 177C71.5 169.82 77.3203 164 84.5 164H110.5C117.68 164 123.5 169.82 123.5 177V203C123.5 210.18 117.68 216 110.5 216H84.5C77.3203 216 71.5 210.18 71.5 203V177Z'
				fill='#EDEDEF'
			/>
			<path
				d='M71.5 244C71.5 236.82 77.3203 231 84.5 231H110.5C117.68 231 123.5 236.82 123.5 244V270C123.5 277.18 117.68 283 110.5 283H84.5C77.3203 283 71.5 277.18 71.5 270V244Z'
				fill='#EDEDEF'
			/>
			<path
				d='M71.5 311C71.5 303.82 77.3203 298 84.5 298H110.5C117.68 298 123.5 303.82 123.5 311V337C123.5 344.18 117.68 350 110.5 350H84.5C77.3203 350 71.5 344.18 71.5 337V311Z'
				fill='#EDEDEF'
			/>
			<path
				d='M269.5 110C269.5 102.82 275.32 97 282.5 97H308.5C315.68 97 321.5 102.82 321.5 110V136C321.5 143.18 315.68 149 308.5 149H282.5C275.32 149 269.5 143.18 269.5 136V110Z'
				fill='#EDEDEF'
			/>
			<path
				d='M269.5 177C269.5 169.82 275.32 164 282.5 164H308.5C315.68 164 321.5 169.82 321.5 177V203C321.5 210.18 315.68 216 308.5 216H282.5C275.32 216 269.5 210.18 269.5 203V177Z'
				fill='#EDEDEF'
			/>
			<path
				d='M269.5 244C269.5 236.82 275.32 231 282.5 231H308.5C315.68 231 321.5 236.82 321.5 244V270C321.5 277.18 315.68 283 308.5 283H282.5C275.32 283 269.5 277.18 269.5 270V244Z'
				fill='#EDEDEF'
			/>
			<path
				d='M269.5 311C269.5 303.82 275.32 298 282.5 298H308.5C315.68 298 321.5 303.82 321.5 311V337C321.5 344.18 315.68 350 308.5 350H282.5C275.32 350 269.5 344.18 269.5 337V311Z'
				fill='#EDEDEF'
			/>
			<path
				d='M203.5 110C203.5 102.82 209.32 97 216.5 97H242.5C249.68 97 255.5 102.82 255.5 110V136C255.5 143.18 249.68 149 242.5 149H216.5C209.32 149 203.5 143.18 203.5 136V110Z'
				fill='#EDEDEF'
			/>
			<path
				d='M203.5 311C203.5 303.82 209.32 298 216.5 298H242.5C249.68 298 255.5 303.82 255.5 311V337C255.5 344.18 249.68 350 242.5 350H216.5C209.32 350 203.5 344.18 203.5 337V311Z'
				fill='#EDEDEF'
			/>
			<path
				d='M137.5 110C137.5 102.82 143.32 97 150.5 97H176.5C183.68 97 189.5 102.82 189.5 110V136C189.5 143.18 183.68 149 176.5 149H150.5C143.32 149 137.5 143.18 137.5 136V110Z'
				fill='#EDEDEF'
			/>
			<path
				d='M137.5 194C137.5 177.431 150.931 164 167.5 164H225.5C242.069 164 255.5 177.431 255.5 194V253C255.5 269.569 242.069 283 225.5 283H167.5C150.931 283 137.5 269.569 137.5 253V194Z'
				fill='#0455A3'
			/>
			<path
				d='M196.5 179C220.801 179 240.5 198.699 240.5 223C240.5 247.301 220.801 267 196.5 267C172.199 267 152.5 247.301 152.5 223C152.5 198.699 172.199 179 196.5 179ZM196.5 182.127C173.926 182.127 155.627 200.426 155.627 223C155.627 245.574 173.926 263.873 196.5 263.873C219.074 263.873 237.373 245.574 237.373 223C237.373 200.426 219.074 182.127 196.5 182.127ZM214.486 237.3C215.124 237.3 215.715 237.641 216.035 238.194L221.144 247.044C221.548 247.744 221.435 248.631 220.844 249.181C214.461 255.118 205.905 258.75 196.5 258.75C182.812 258.75 170.921 251.057 164.914 239.759C164.309 238.621 165.168 237.3 166.456 237.3H214.486ZM204.817 189.569C205.218 188.873 206.037 188.527 206.807 188.758C221.527 193.183 232.25 206.839 232.25 223C232.25 229.808 230.347 236.172 227.043 241.588C226.368 242.695 224.782 242.62 224.133 241.497L200.001 199.698C199.682 199.145 199.682 198.464 200.001 197.911L204.817 189.569ZM197.091 187.254C198.393 187.275 199.131 188.692 198.48 189.821L174.679 231.044C174.36 231.597 173.77 231.938 173.131 231.938H163.262C162.446 231.937 161.729 231.386 161.557 230.589C161.028 228.143 160.75 225.604 160.75 223C160.75 203.256 176.756 187.25 196.5 187.25C196.697 187.25 196.894 187.251 197.091 187.254ZM194.84 206.848C195.528 205.656 197.249 205.656 197.937 206.848L210.874 229.256C211.562 230.448 210.702 231.937 209.326 231.938H183.451C182.076 231.937 181.216 230.448 181.904 229.256L194.84 206.848Z'
				fill='white'
			/>
			<path
				d='M137.5 311C137.5 303.82 143.32 298 150.5 298H176.5C183.68 298 189.5 303.82 189.5 311V337C189.5 344.18 183.68 350 176.5 350H150.5C143.32 350 137.5 344.18 137.5 337V311Z'
				fill='#EDEDEF'
			/>
		</svg>
	);
};

export default PWAInstructionLogo;
